import React from 'react';
import { Key } from 'lucide-react';
import { ResetPassword } from '../../components/auth/ResetPassword';
import { PageLayout } from '../../components/layout/PageLayout';
import { useTranslation } from '../../hooks/useTranslation';
import { SEO } from '../../components/seo/SEO';

export function ResetPasswordPage() {
  const { t } = useTranslation();

  return (
    <PageLayout
      disableAds={true}
      className="bg-gray-50"
    >
      <SEO
        title={t('auth.reset_password.seo.title')}
        description={t('auth.reset_password.seo.description')}
      />
      <div className="min-h-[calc(100vh-4rem)] flex flex-col justify-center py-6 sm:py-12 sm:px-6 lg:px-8">
        <div className="text-center sm:mx-auto sm:w-full sm:max-w-md">
          <div className="flex justify-center">
            <div className="w-12 h-12 bg-primary-100 rounded-xl flex items-center justify-center">
              <Key className="w-6 h-6 text-primary-600" />
            </div>
          </div>
          <h2 className="mt-4 text-2xl sm:text-3xl font-bold text-gray-900">
            {t('auth.reset_password.title')}
          </h2>
        </div>

        <div className="mt-6 sm:mt-8 sm:mx-auto sm:w-full sm:max-w-md px-4 sm:px-0">
          <div className="bg-white py-6 sm:py-8 px-4 shadow-xl sm:rounded-lg sm:px-10">
            <ResetPassword />
          </div>
        </div>
      </div>
    </PageLayout>
  );
}